export default "__VITE_ASSET__98c7605a__"